/**
 * @generated SignedSource<<945c125d62f0796787bc85421bb3498a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CodepushVersionActionEnum = "codepush_version_update_production" | "codepush_version_update_staging" | "%future added value";
export type CodepushVersionStagingUpdateInput = {
  id: string;
};
export type CodepushVersionId_codepushVersionStagingUpdateMutation$variables = {
  input: CodepushVersionStagingUpdateInput;
};
export type CodepushVersionId_codepushVersionStagingUpdateMutation$data = {
  readonly codepushVersionStagingUpdate: {
    readonly actions: ReadonlyArray<CodepushVersionActionEnum>;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"CodepushVersionStatusLabel_codepushVersion">;
  };
};
export type CodepushVersionId_codepushVersionStagingUpdateMutation = {
  response: CodepushVersionId_codepushVersionStagingUpdateMutation$data;
  variables: CodepushVersionId_codepushVersionStagingUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actions",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CodepushVersionId_codepushVersionStagingUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CodepushVersion",
        "kind": "LinkedField",
        "name": "codepushVersionStagingUpdate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CodepushVersionStatusLabel_codepushVersion"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CodepushVersionId_codepushVersionStagingUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CodepushVersion",
        "kind": "LinkedField",
        "name": "codepushVersionStagingUpdate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e45b3cab86af5086429a2b7ae0b53252",
    "id": null,
    "metadata": {},
    "name": "CodepushVersionId_codepushVersionStagingUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation CodepushVersionId_codepushVersionStagingUpdateMutation(\n  $input: CodepushVersionStagingUpdateInput!\n) {\n  codepushVersionStagingUpdate(input: $input) {\n    id\n    actions\n    ...CodepushVersionStatusLabel_codepushVersion\n  }\n}\n\nfragment CodepushVersionStatusLabel_codepushVersion on CodepushVersion {\n  status\n}\n"
  }
};
})();

(node as any).hash = "c216a07fa6eb12852113526297367bc5";

export default node;
